module.exports = __webpack_public_path__ + "static/sala-inteligente-nova-f3077ff8babb601b54f030cd7defc058.jpg";